// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { cartTotalStyles } from "@monsma/Overrides/Widgets/Cart/CartTotal";
import { cartTotalStyles as shippingCartTotalStyles } from "@monsma/Overrides/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import Edit from "@monsma/XDL/Icons/Edit";
import { css } from "styled-components";

shippingCartTotalStyles.xStyle = {
    wrapper: cartTotalStyles.xStyle?.wrapper,
    title: cartTotalStyles.xStyle?.title,
    itemsCount: cartTotalStyles.xStyle?.itemsCount,
    editCart: {
        icon: {
            iconProps: {
                src: Edit,
                size: 12,
                color: "common.ui5",
            },
            position: "left",
        },
        css: css`
            position: absolute;
            top: 17px;
            right: 20px;
            ${getProp("theme.link.defaultProps.css")};
        `,
    },
};

shippingCartTotalStyles.continueButton = {
    css: css`
        display: none;
    `,
};
